import {
  AuthPagesNavigationParams,
  authPagesNavigationConfig,
} from "../auth/pages/navigation-config";
import {
  CommonPagesNavigationParams,
  commonPagesNavigationConfig,
} from "../common/pages/navigation-config";
import {
  ConferencePagesNavigationParams,
  conferencePagesNavigationConfig,
} from "../conference/pages/navigation-config";
import {
  ContactsPagesNavigationParams,
  contactsPagesNavigationConfig,
} from "../contacts/navigation-config";
import {
  CustomersPagesNavigationParams,
  customersPagesNavigationConfig,
} from "../customers/pages/navigation-config";
import {
  DrivePagesNavigationParams,
  drivePagesNavigationConfig,
} from "../drive/pages/navigation-config";
import {
  ReportsPagesNavigationParams,
  reportsPagesNavigationConfig,
} from "../reports/pages/navigation-config";
import {
  TravelLogPagesNavigationParams,
  travelLogPagesNavigationConfig,
} from "../travel-log/pages/navigation-config";
import {
  SettingsPagesNavigationParams,
  settingsPagesNavigationConfig,
} from "../settings/pages/navigation-config";
import {
  WorkspacePagesNavigationParams,
  workspacePagesNavigationConfig,
} from "../workspace/pages/navigation-config";
import {
  PeoplePagesNavigationParams,
  peoplePagesNavigationConfig,
} from "../people/pages/navigation-config";
import {
  TasksPagesNavigationParams,
  tasksPagesNavigationConfig,
} from "../tasks/pages/navigation-config";
import {
  ChatsPagesNavigationParams,
  chatsPagesNavigationConfig,
} from "../chats/pages/navigation-config";
import {
  CallsPagesNavigationParams,
  callsPagesNavigationConfig,
} from "../calls/pages/navigation-config";
import {
  ordersPagesNavigationConfig,
  OrdersPagesNavigationParams,
} from "../orders/pages/navigation-config";
import {
  inventoryPagesNavigationConfig,
  InventoryPagesNavigationParams,
} from "../inventory/pages/navigation-config";
import {
  clientSupportPagesNavigationConfig,
  ClientSupportPagesNavigationParams,
} from "../client-support/pages/navigation-config";
import {
  dashboardPagesNavigationConfig,
  DashboardPagesNavigationParams,
} from "../dashboard/pages/navigation-config";
import {
  invoicesPagesNavigationConfig,
  InvoicesPagesNavigationParams,
} from "../invoices/pages/navigation-config";
import {
  automationPagesNavigationConfig,
  AutomationPagesNavigationParams,
} from "../automation/pages/navigation-config";
import {
  boardAutomationPagesNavigationConfig,
  BoardAutomationPagesNavigationParams,
} from "../board-automation/pages/navigation-config";
import {
  cxPagesNavigationConfig,
  CXPagesNavigationParams,
} from "../cx/pages/navigation-config";

import {
  trialPagesNavigationConfig,
  TrialPagesNavigationParams,
} from "../trial/pages/navigation-config";

export type RootPagesNavigationParams = PeoplePagesNavigationParams &
  AuthPagesNavigationParams &
  DashboardPagesNavigationParams &
  DrivePagesNavigationParams &
  CommonPagesNavigationParams &
  ConferencePagesNavigationParams &
  CustomersPagesNavigationParams &
  ContactsPagesNavigationParams &
  ReportsPagesNavigationParams &
  TravelLogPagesNavigationParams &
  SettingsPagesNavigationParams &
  WorkspacePagesNavigationParams &
  TasksPagesNavigationParams &
  ChatsPagesNavigationParams &
  CallsPagesNavigationParams &
  OrdersPagesNavigationParams &
  InventoryPagesNavigationParams &
  InvoicesPagesNavigationParams &
  ClientSupportPagesNavigationParams &
  AutomationPagesNavigationParams &
  BoardAutomationPagesNavigationParams &
  CXPagesNavigationParams &
  TrialPagesNavigationParams;

export const rootNavigationPageConfig = {
  ...peoplePagesNavigationConfig,
  ...authPagesNavigationConfig,
  ...dashboardPagesNavigationConfig,
  ...drivePagesNavigationConfig,
  ...commonPagesNavigationConfig,
  ...conferencePagesNavigationConfig,
  ...customersPagesNavigationConfig,
  ...contactsPagesNavigationConfig,
  ...reportsPagesNavigationConfig,
  ...travelLogPagesNavigationConfig,
  ...settingsPagesNavigationConfig,
  ...workspacePagesNavigationConfig,
  ...tasksPagesNavigationConfig,
  ...chatsPagesNavigationConfig,
  ...callsPagesNavigationConfig,
  ...ordersPagesNavigationConfig,
  ...inventoryPagesNavigationConfig,
  ...invoicesPagesNavigationConfig,
  ...clientSupportPagesNavigationConfig,
  ...automationPagesNavigationConfig,
  ...boardAutomationPagesNavigationConfig,
  ...cxPagesNavigationConfig,
  ...trialPagesNavigationConfig,
};
